import {
  MANUAL_WORK_ALL,
  MANUAL_WORK_POST,
  MANUAL_WORK_DEL,
  MANUAL_WORK_LOADING,
  MANUAL_WORK_ERROR,
} from '../../actions/types';

const initialState = {
  rows: [],
  isLoading: false,
  isCompleted: true,
};

export default function ManualWorkEntryReducer(state = initialState, action) {
  switch (action.type) {
    case MANUAL_WORK_ALL:
      return { ...state, rows: action.payload.rows || [], isLoading: false, isCompleted: true };

    case MANUAL_WORK_POST: {
      // upsert: แทนที่ถ้ามีอยู่แล้ว ไม่งั้นเพิ่มใหม่
      const updated = action.payload;
      const exists = state.rows.find((r) => r._id === updated._id);
      const rows = exists
        ? state.rows.map((r) => (r._id === updated._id ? updated : r))
        : [...state.rows, updated];
      return { ...state, rows, isLoading: false, isCompleted: true };
    }

    case MANUAL_WORK_DEL:
      return { ...state, rows: state.rows.filter((r) => r._id !== action.payload) };

    case MANUAL_WORK_LOADING:
      return { ...state, isLoading: true };

    case MANUAL_WORK_ERROR:
      return { ...state, isLoading: false, isCompleted: false };

    default:
      return state;
  }
}
